import { OustAccessTypes, Profession } from "../commons/interfaces";
import { UploadTypes } from "../constants/commons";

export const URL = {
  // ***PRE-LOGIN SCREEN***
  // [POST] API for Sign in
  postSignIn: "/sign-up/send-otp",
  // [POST] API for sending OTP
  postsendOTP: "/sign-up/verify-otp",
  // [POST] API for the final Signin/SignUp Flow
  postFinalSigninUpFlow: "/sign-up",
  // [POST] API for uploading
  postUploadEndPoint: (leadID: string) => `/lead/file/${leadID}`,
  // [POST] API for uploading the final Selfie Video
  postUploadFinalSelfieVideoCall: (leadId: string) =>
    `lead/file/${leadId}/update`,
  // [POST] API for selfie uploading
  postSelfieUploadGetUrl: (leadID: string, filename: string) =>
    `lead/file/${leadID}/SELFIE_VIDEO/${filename}`,

  // [GET] API to get the profile picture
  getProfilePicture: (leadID: string) => `/lead/profile-picture/${leadID}`,

  // API for fetching the status in registeration page
  getStatusDetails: (leadID: string) => `/lead/step-status/${leadID}`,

  // [GET] Common Configs API to fetch Languages
  getLanguageList: "/common/languages",
  // [GET] Common Configs API to fetch Professions
  getProfessionsList: "/common/professions",
  // [GET] Common Configs API to fetch ENABLED Professions
  getEnabledProfessionsList: "/common/enabledProfessions",
  // [GET] Common Configs API to fetch Degree List
  getDegreeList: "/common/degrees",
  // [DELETE] Top remove the uploaded Image
  removeUploadedAsset: (leadID: string, fileId: string, fileName: string) =>
    `/lead/file/${leadID}/${fileId}/${fileName}`,
  // [GET] For downloading GST/TEmplates
  downloadTemplatesContracts: (leadId: string, uploadType: UploadTypes) =>
    `/lead/presignedUrl/${leadId}/uploadtype/${uploadType}`,

  // ***BASIC INFORMATION PAGE***

  // [POST] API for saving data
  postBasicInformation: (leadId: string) => `/lead/basic-info/${leadId}`,
  // [GET] API to fetch existing saved data
  getBasicInformation: (leadId: string) => `/lead/basic-info/${leadId}`,
  // [GET] API to fetch the country, state and city
  getLocationDetails: "/common/location",

  // ***DIGITAL COURSES PAGE / FINAL ASSESSMENT PAGE***
  // [GET] API to fetch existing saved data
  getOustDetails: (leadId: string, assessmentType: OustAccessTypes) =>
    `/lead/oust-details/${leadId}/${assessmentType}`,

  // ***LANGUAGE PROFICIENCY***

  // [POST] API for saving data
  postLanguageProficiency: (leadID: string) =>
    `/lead/language-proficiency-info/${leadID}`,
  // [GET] API to fetch existing saved data
  getLanguageProficiency: (leadID: string) =>
    `/lead/language-proficiency-info/${leadID}`,
  // [GET] API to fetch the languages available

  // ***PROFESSIONAL DETAILS***

  // [POST] API for saving data
  postProfessionalDetails: (leadID: string) =>
    `/lead/profession-info/${leadID}`,
  // [GET] API to fetch existing saved data
  getProfessionalDetails: (leadID: string) => `/lead/profession-info/${leadID}`,

  // ***SELFIE VIDEO PAGE***

  // [GET] API for fetching data on page load
  getSelfieVideoPage: (leadID: string) => `/lead/selfie-video/${leadID}`,
  // [POST] API for saving data
  postSelfieVideoPage: (leadID: string) => `/lead/selfie-video/${leadID}`,

  // ***WORKPLACE DETAILS***

  // [POST] API for saving data
  postWorkplaceDetails: (leadId: string) => `/lead/workspace-info/${leadId}`,
  // [GET] API to fetch existing saved data
  getWorkplaceDetails: (leadId: string) => `/lead/workspace-info/${leadId}`,

  // [GET] API to get the Preliminary Quiz page details on Page load
  getPreliminaryQuizInfo: (leadID: string) =>
    `/lead/preliminary-quiz-info/${leadID}`,

  // ***CONGRATULATIONS PAGE***

  // [GET] API for congratulatory Page
  getCongratulatoryDetails: (leadID: string, showAnnexure: boolean) =>
    `/lead/contract/${leadID}?tds=${showAnnexure}`,
  // [POST] API for congratulatory Page
  postCongratulatorydetails: (leadID: string) =>
    `/lead/${leadID}/accept/contract`,

  // ***AGREEMENT PAGE***

  // [GET] API for congratulatory Page
  getTDSDetails: (leadID: string) => `/lead/tds/${leadID}`,
  // [POST] API for congratulatory Page
  postTDSDetails: (leadID: string) => `/lead/${leadID}/accept/tds`,

  // ***WELCOME ABOARD PAGE***

  // [GET] API for fetching media files for HOW TO USE section
  getHowtoUseMediaList: (profession: Profession) =>
    `common/welcome-page?profession=${profession}`,

  // ***PUBLIC PROFILE DETAILS***

  // [POST] API for saving data
  postPublicProfileDetails: (leadId: string) =>
    `/lead/profile-details/${leadId}`,
  // [GET] API to fetch existing saved data
  getPublicProfileDetails: (leadId: string) =>
    `/lead/profile-details/${leadId}`,

  // ***KYC DETAILS PAGE***

  // [POST] API for saving data
  postKYCDetails: (leadId: string) => `/lead/kyc-details/${leadId}`,
  // [GET] API to fetch existing saved data
  getKYCDetails: (leadId: string) => `/lead/kyc-details/${leadId}`,

  // ***BANK ACCOUNT DETAILS***

  // [POST] API for saving data
  postBankAccountDetails: (leadId: string) => `/lead/bank-details/${leadId}`,
  // [GET] API to fetch existing saved data
  getBankAccountDetails: (leadId: string) => `/lead/bank-details/${leadId}`,

  //GET API to get the form from CFS
  getUserForm: (userId: string) => `/cfs/userform/?userId=${userId}`,

  //GET API for QUIZ Responses
  getQuizResponse: (userId: string) => `/common/quiz/?userId=${userId}`,

  //POST API to submit the form from CFS
  postUserForm: (userId: string) => `/cfs/userform/?userId=${userId}`,

  //GET API to get the dashboard data
  getDashboardDetails: (leadID: string) => `lead/dashboard-status/${leadID}`,

  //GET API to get the partner speaks data
  getTestimonialsData: (profession: Profession | "") =>
    `/common/testimonials?profession=${profession}`,

  //POST API to get FAQ's
  getFAQDetails: `/common/faq`,

  //GET API to start onboarding
  initiateOnboarding: (leadId: string) => `/lead/initiate/${leadId}`,
};

export const API_BASE_URL = "";
